<div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title text-center">Dispatch Group  Way Bill</h5>
      
  <!-- Excel Export Button, Date Filters, and Search Filters in One Row -->
  <div class="row mb-3 align-items-center">
  
  
    <!-- From Date Filter -->
    <div class="col-md-auto">
      <label for="fromDate" class="form-label">From Date</label>
      <input type="date" id="fromDate" class="form-control" [(ngModel)]="fromDate" (change)="applyFilters()">
    </div>
  
    <!-- To Date Filter -->
    <div class="col-md-auto">
      <label for="toDate" class="form-label">To Date</label>
      <input type="date" id="toDate" class="form-control" [(ngModel)]="toDate" (change)="applyFilters()">
    </div>
  
    <!-- Search Filters for clientName, refNo, ticketNo, and jobName -->
    <div class="col-md-auto">
      <label for="clientNameSearch" class="form-label">Search by Customer</label>
      <input type="text" id="clientNameSearch"  placeholder="Customer"  class="form-control" [(ngModel)]="search.clientName" (input)="applyFilters()">
    </div>
    <div class="col-md-auto">
      <label for="refNoSearch" class="form-label">Search by Ref No</label>
      <input type="text" id="refNoSearch" placeholder="Ref No" class="form-control" [(ngModel)]="search.refNo" (input)="applyFilters()">
    </div>
    <div class="col-md-auto">
      <label for="ticketNoSearch" class="form-label">Search by Ticket No</label>
      <input type="text" id="ticketNoSearch" placeholder="Ticket No"  class="form-control" [(ngModel)]="search.ticketNo" (input)="applyFilters()">
    </div>
    <div class="col-md-auto">
      <label for="jobNameSearch" class="form-label">Search by Job Name</label>
      <input type="text" id="jobNameSearch" placeholder="Job Name" class="form-control" [(ngModel)]="search.jobName" (input)="applyFilters()">
    </div>
    
      <!-- Excel Export Button (Aligned to Right) -->
  <!-- <div class="col-auto ms-auto">
    <button class="highlight-link" (click)="exportToExcel()">Export to Excel</button>
  </div> -->
  
  </div>
  
      <!-- Table -->
      <div class="table-responsive" style="max-height: 700px; overflow-y: auto;">
        <table class="table table-bordered table-responsive">
          <thead>
            <tr>
              <th (click)="sortTable('preview')">Preview</th>
              <th (click)="sortTable('status')">
                Status
                <span *ngIf="currentSortColumn === 'status'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('created')">
                Date
                <span *ngIf="currentSortColumn === 'created'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('ticketNo')">
                Ticket No
                <span *ngIf="currentSortColumn === 'ticketNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('refNo')">
                Ref No
                <span *ngIf="currentSortColumn === 'refNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('poNo')">
                PO Number
                <span *ngIf="currentSortColumn === 'poNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('clientName')">
                Customer
                <span *ngIf="currentSortColumn === 'clientName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('jobName')">
                Job Name
                <span *ngIf="currentSortColumn === 'jobName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('orderKgs')">
                Kgs Bal
                <span *ngIf="currentSortColumn === 'orderKgs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('orderPcs')">
                Pcs
                <span *ngIf="currentSortColumn === 'orderPcs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('dispatched')">
                Total Disp
                <span *ngIf="currentSortColumn === 'dispatched'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <!-- <th (click)="sortTable('kgsBal')">
                Order Bal
                <span *ngIf="currentSortColumn === 'kgsBal'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
              <th>Dispatch Details</th>
            </tr>
          </thead>
          <!-- <tbody>
            <tr *ngFor="let dispatch of filteredDispatchesList">
              <td><button class="highlight-link fn" (click)="previewDispatch(dispatch.dispatchId)"><i class="feather icon-printer"></i> Preview</button></td>
              <td [ngClass]="{'text-primary': dispatch.status === 'Open', 'text-success': dispatch.status === 'Closed'}">{{ dispatch.status }}</td>
              <td>{{ dispatch.created | date }}</td>
              <td>{{ dispatch.ticketNo }}</td>
              <td>{{ dispatch.refNo }}</td>
              <td>{{ dispatch.poNo }}</td>
              <td>{{ dispatch.clientName }}</td>
              <td>{{ dispatch.jobName }}</td>
              <td>{{ dispatch.orderKgs }}</td>
              <td>{{ dispatch.orderPcs }}</td>
              <td>{{ dispatch.totalDispatched }}</td>
              <td>{{ dispatch.totalKgsBal }}</td>
              <td class="dispatch-details">
                <div *ngFor="let detail of dispatch.dispatchDetails; let i = index" class="dispatch-item">
                  <span>{{ dispatch.dispatchDetails.length > 1 ? 'Dispatch ' + (i + 1) : 'Dispatch' }} - Date: </span> 
                  {{ detail.dispatchDate | date }},
                  <span> Dispatched: </span>{{ detail.disp }} Kgs
                </div>
              </td>
              
            
            </tr>
            <tr *ngIf="filteredDispatchesList.length === 0">
              <td colspan="8" class="text-center">No dispatches available</td>
            </tr>
          </tbody> -->
            <tbody>
          <tr *ngFor="let dispatch of getCurrentPageData()">
            <td><button class="highlight-link fn" (click)="previewDispatch(dispatch.dispatchId)"><i class="feather icon-printer"></i> Preview</button></td>
            <td [ngClass]="{'text-primary': dispatch.status === 'Open', 'text-success': dispatch.status === 'Closed'}">{{ dispatch.status }}</td>
            <td>{{ dispatch.created | date }}</td>
            <td>{{ dispatch.ticketNo }}</td>
            <td>{{ dispatch.refNo }}</td>
            <td>{{ dispatch.poNo }}</td>
            <td>{{ dispatch.clientName }}</td>
            <td>{{ dispatch.jobName }}</td>
            <td>{{ dispatch.orderKgs }}</td>
            <td>{{ dispatch.orderPcs }}</td>
            <td>{{ dispatch.totalDispatched }}</td>
            <td class="dispatch-details">
              <div *ngFor="let detail of dispatch.dispatchDetails; let i = index" class="dispatch-item">
                <span>{{ dispatch.dispatchDetails.length > 1 ? 'Dispatch ' + (i + 1) : 'Dispatch' }} - Date: </span> 
                {{ detail.dispatchDate | date }},
                <span> Dispatched: </span>{{ detail.disp }} Kgs
              </div>
            </td>
          </tr>
          <tr *ngIf="getCurrentPageData().length === 0">
            <td colspan="8" class="text-center">No dispatches available</td>
          </tr>
        </tbody>
        </table>
        
      </div>

       <!-- Pagination Controls -->
    <div class="pagination-controls text-center">
      <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
      
      <span>
        Showing {{ getStartIndex() + 1 }} - {{ getEndIndex() }} of {{ filteredDispatchesList.length }}
      </span>
      
      <button (click)="changePage(currentPage + 1)" [disabled]="currentPage * itemsPerPage >= filteredDispatchesList.length">Next</button>
    </div>



    
    </div>
  </div>
  